/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {CalculationErrorInfo} from './CalculationErrorInfo';
import {
  CalculationErrorInfoFromJSON,
  CalculationErrorInfoFromJSONTyped,
  CalculationErrorInfoToJSON
} from './CalculationErrorInfo';
import type {CalculationStatusEnum} from './CalculationStatusEnum';
import {
  CalculationStatusEnumFromJSON,
  CalculationStatusEnumFromJSONTyped,
  CalculationStatusEnumToJSON
} from './CalculationStatusEnum';

/**
 *
 * @export
 * @interface CalculationTaskRunStatus
 */
export interface CalculationTaskRunStatus {
  /**
   *
   * @type {number}
   * @memberof CalculationTaskRunStatus
   */
  number: number;
  /**
   *
   * @type {CalculationStatusEnum}
   * @memberof CalculationTaskRunStatus
   */
  statusCode: CalculationStatusEnum;
  /**
   *
   * @type {Array<CalculationErrorInfo>}
   * @memberof CalculationTaskRunStatus
   */
  errorInfo: Array<CalculationErrorInfo>;
}

/**
 * Check if a given object implements the CalculationTaskRunStatus interface.
 */
export function instanceOfCalculationTaskRunStatus(
  value: object
): value is CalculationTaskRunStatus {
  if (!('number' in value) || value['number'] === undefined) return false;
  if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
  if (!('errorInfo' in value) || value['errorInfo'] === undefined) return false;
  return true;
}

export function CalculationTaskRunStatusFromJSON(json: any): CalculationTaskRunStatus {
  return CalculationTaskRunStatusFromJSONTyped(json, false);
}

export function CalculationTaskRunStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculationTaskRunStatus {
  if (json == null) {
    return json;
  }
  return {
    number: json['number'],
    statusCode: CalculationStatusEnumFromJSON(json['status_code']),
    errorInfo: (json['error_info'] as Array<any>).map(CalculationErrorInfoFromJSON)
  };
}

export function CalculationTaskRunStatusToJSON(value?: CalculationTaskRunStatus | null): any {
  if (value == null) {
    return value;
  }
  return {
    number: value['number'],
    status_code: CalculationStatusEnumToJSON(value['statusCode']),
    error_info: (value['errorInfo'] as Array<any>).map(CalculationErrorInfoToJSON)
  };
}
